import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Rating,
  Box,
} from '@mui/material';
import COLORS from '../Utils/colors';

interface AddReviewDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { rating: number; review: string }) => void;
}

const AddReviewDialog: React.FC<AddReviewDialogProps> = ({ open, onClose, onSubmit }) => {
  const [rating, setRating] = useState<number | null>(0);
  const [comment, setComment] = useState('');

  const handleSubmit = () => {
    if (rating) {
      onSubmit({ rating, review: comment });
      setRating(0);
      setComment('');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add review</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
          <Rating
            value={rating}
            onChange={(_, newVal) => setRating(newVal)}
            size="large"
          />
        </Box>
        <TextField
          label="Comment"
          multiline
          rows={4}
          fullWidth
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Enter your comments here"
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={handleSubmit}
          disabled={!rating}
          sx={{
            bgcolor: COLORS.primary,
            '&:hover': { bgcolor: '#e55a2b' },
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddReviewDialog; 